import { Injectable, NgZone, ViewChild } from '@angular/core';
import { State, ControlStatusService } from './control-status.service';
import { EsriLoadService, LoadedModules } from './esri-load-control.service';
import { RouteService } from './route.service';
import { environment } from '../../environments/environment';
import { ConfiguracaoInfoCliente, TipoEntregas, Util } from '../shared/Util';
import { isNullOrUndefined, isNull } from 'is-what';
import { BoxHistoricoAcoesService } from '../box-historico-acoes/box-historico-acoes.service';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { SvgService } from './svg.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DecimalPipe } from '@angular/common';
import { BoxInfoRouterService } from '../box-info-router/box-info-router.service';
import { BoxInfoAlertService } from '../box-info-alert/box-info-alert.service';

let graphicService: GraphicService;
declare var jquery: any;
declare var $: any;

@Injectable()
export class GraphicService {
  map: any;
  view: any;

  linhaRotaPlanejada: any;
  linhaRota: any[] = [];
  pontoRota: any[] = [];
  public listaPedagios: any = [];
  mostraConfiguracaoRoteiro = false;

  public layers: any[] = [];
  public ultimaPosicao: any;
  public distanciaTotalRealizada: number = 0;
  public distanciaTotalPlanejada: number = 0;
  public percentualDistancia: number = 0;
  public posicaoCliente: {};
  public numeroRoteiroAcesso: number = 0;
  public duracaoTotalEntrega: string;
  listaOcPedagioCriada: Array<number> = [];
  numeroClienteFoco = 0
  coordenadaCenter = null;
  pointBarriers: any[] =[];
  polygonGraphicCerca = null;
  corDistanciaPercorrida = '#f00'
  dadosAjudMotorDisPerc = null;
  listaPolylineDistPercorrida = [];
  configNomeClienteExibicao = ConfiguracaoInfoCliente.RazaoSocial;
  enumConfiguracaoInfoCliente = ConfiguracaoInfoCliente;
  urlOcorrencias: string = environment.url_telaOcorrencias + '/index.html' + window.location.search;

  constructor
    (
      private esriLoadService: EsriLoadService,
      private controlStatus: ControlStatusService,
      private routeService: RouteService,
      private util: Util,
      public boxHistoricoAcoesService: BoxHistoricoAcoesService,
      private boxListTruckService: BoxListTruckService,
      private svgService: SvgService,
      private sanitizer:DomSanitizer,
      private boxInfoAlertService: BoxInfoAlertService,
      public ngZone: NgZone,
    ) {
    graphicService = this;
  }

  iniLayers() {
    this.layers[State.visualizadorLinhasPontos] = new LoadedModules.GraphicsLayer();
    this.layers[State.visualizadorDeRoteiros] = new LoadedModules.GraphicsLayer();

    this.map.add(this.layers[State.visualizadorLinhasPontos]);
    this.map.add(this.layers[State.visualizadorDeRoteiros]);
  }

  createSymbol(client: any, tipoIcone?: number, catPedagioID = 0) {

    let url = '';
    let altura = 0;
    let largura = 0;
    let options
    switch (tipoIcone) {
      case 1:

        if(catPedagioID == 0 || catPedagioID == 1 ){
          options = { icone: "RotaGPSCaminhao", NumeroRoteiro: client.NumeroRoteiro }
          altura = 32;
          largura = 47;
        }else{
          const infoRota = JSON.parse(this.boxListTruckService.listTruckService.InfoRota);
          const corVeiculo = infoRota.CorVeiculo ?? null;
          options = { icone: Util.descricaoVeiculoEixo(catPedagioID), NumeroRoteiro: client.NumeroRoteiro, corVeiculo }
          let dadosAlturaLargura  = Util.obterDimensoesIconePorCategoria(catPedagioID);
          altura = dadosAlturaLargura.altura;
          largura = dadosAlturaLargura.largura;
        }          
        url = this.svgService.geraSVG(options)      
        break;
      case 2:

        url = client.urlImagemRoteiro;
        altura = 39.75;
        largura = 30.75;
        break;
      case 3:
        url = 'assets/img/icon-ponto-partida.png';
        altura = 38;
        largura = 26;
        break;
      case 4:
        url = this.retornaIcone(client);
        altura = 30;
        largura = 30;
        break;
    }

    client.urlIcon =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
    return new LoadedModules.PictureMarkerSymbol
      ({
        'url': url,
        'height': altura,
        'width': largura,
        'contentType': 'image/svg+xml'
      });
  }

  private async criarPontoRota(list: any, ultimaPosicao?: boolean) {

    let listaDeAcoes = await this.boxHistoricoAcoesService.getListaDeAcoes();

    //Verifica clientes com coordenadas iguais.
    let coordenadas = {};
    let controle = 1 ;
    list.forEach(cliente => {
        let chave = `${cliente.Latitude.toFixed(6)}_${cliente.Longitude.toFixed(6)}`;
        if (coordenadas[chave]) { 
            cliente.Latitude -= 0.0005 * controle;
            cliente.Longitude -= 0.0005 * controle;
            controle++
            chave = `${cliente.Latitude.toFixed(6)}_${cliente.Longitude.toFixed(6)}`;
        }
        coordenadas[chave] = true;
    });

    if(list.length){
    let infoRota = JSON.parse(list[0].InfoRota);
      this.configNomeClienteExibicao = infoRota.ConfigNomeClienteExibicao
    }

    // Insere os pontos de rota
    for (let i = 0, len = list.length; i < len; i++) {
      let client = list[i];
      let tipoIcone = 2;

      let acoes = listaDeAcoes.filter(x => client.CodigoCliente == x.CodigoCliente);
      let infoTemplate = this.criarInfoTemplateRoteiro(ultimaPosicao, client, acoes);
      let acoesAux = [];

      if (ultimaPosicao) {
        tipoIcone = 1
      }
      else if (acoes != undefined) {
        //Popular lista de acoes
        acoesAux = this.iconeAcaoPopup(acoes);
      };

      if (acoes.length == 0 && client.statusEntrega > 1) {

        let listaDeAcoesPorPedido = await this.boxHistoricoAcoesService.getListaDeAcoesPorPedido(client.CodigoCliente);
        acoesAux = this.iconeAcaoPopupPorPedido(listaDeAcoesPorPedido);

      }
      let symbol = this.createSymbol(client, tipoIcone);
      if (symbol.url != undefined) {
        let g = new LoadedModules.Graphic
          ({
            geometry:this.CriaPontoMapa(client.Latitude, client.Longitude),
            symbol: symbol,
            attributes: ultimaPosicao ?
              {
                "DATA": this.util.converteData(new Date(client.Data)).toLocaleDateString() + ' ' + this.util.converteData(new Date(client.Data)).toLocaleTimeString(),
                'NumeroRoteiro': client.NumeroRoteiro
              } :
              {
                'NumeroRoteiro': client.NumeroRoteiro,
                'CDCLIENT': client.CodigoCliente,
                'Name': client.CodigoCliente,
                'NOME': this.configNomeClienteExibicao == this.enumConfiguracaoInfoCliente.NomeFantasia? client.NomeFantasia :client.RazaoSocial,
                'NOMEFANTASIA': this.configNomeClienteExibicao == this.enumConfiguracaoInfoCliente.NomeFantasia? client.RazaoSocial : client.NomeFantasia,
                'DOC': graphicService.util.formatarDocumento(client.CnpjCpf),
                'ENDERECO': client.Endereco + "," + client.Numero,
                'BAIRRO': client.Bairro,
                'MUNICIPIO': client.Cidade,
                'UF': client.UF,
                'CEP': graphicService.util.formatarCEP(client.Cep),
                'LATITUDE': client.Latitude,
                'LONGITUDE': client.Longitude,
                'SYMBOLURLSTREET': encodeURI(symbol.url),
                'listaDeAcoes': acoesAux,
                'statusEntrega': client.statusEntrega,
                'custoDescarga': client.custoDescarga
              }
            ,
            popupTemplate: infoTemplate
        });

        client.graphic = g;
        this.addGraphic(g, false);
      }
    }

    this.resetExtent(true, []);
    this.controlStatus.carregando = false;
  }

  public iconeAcaoPopup(listaDeAcoes) {
    let listaAux = [];

    listaDeAcoes.forEach(item => {
      let options
      let informacoes = JSON.parse(item.Informacoes)

      switch (item.IdRoteiroPedidoSituacao) {
        case 2:
          options = { icone: "DashboardChegouCliente" }
          break;
        case 3:
          options = informacoes = informacoes.tipo == TipoEntregas.Coleta?  { icone: "DashboardIniciouColeta" } : { icone: "DashboardIniciouEntrega" }
          break;
        case 4:
          options = { icone: "DashboardVoltaDepois" }
          break;
        case 5:
          options = { icone: "DashboardNaoEntrega" }
          break;
        case 6:
          options = informacoes = informacoes.tipo == TipoEntregas.Coleta?  { icone: "DashboardColetaFinalizada" } : { icone: "DashboardEntregaFinalizada" }
          break;
      }

      if (options != null) {
        let data = this.util.converteData(new Date(item.Data));

        let acao = {
          icone: this.svgService.geraSVG(options),
          data: this.util.formataDataDia(data.getDate()) + '/' + this.util.formataDataMes((data.getMonth() + 1)) + '/' + data.getFullYear(),
          hora: this.util.retornarHora(data),
          descricaoStatus : this.descricaoStatusAcao(item.IdRoteiroPedidoSituacao, JSON.parse(item.Informacoes))
        };

        listaAux.push(acao);
      }
    });

    return listaAux;
  }

  public criarPontoAcao(ponto: any, exibir: boolean) {
    if (exibir) {
      let infoTemplate = this.criarInfoTemplateAcao();

      let symbol = this.createSymbol(ponto, 4);

      let g = new LoadedModules.Graphic
        ({

          geometry: this.CriaPontoMapa(ponto.Latitude, ponto.Longitude),
          symbol: symbol,
          attributes:
          {
            "CDCLIENT": "0",
            "ID": ponto.IdCoordenada,
            "TITULO": "Ação - " + new Date(ponto.Data).toLocaleDateString() + " " + new Date(ponto.Data.replace('Z', '')).toLocaleTimeString(),
            "CORPO": "<p class='m-3'>" + ponto.TextoInfo.toUpperCase() + "</p><p class='m-3'>" + ponto.Cliente + "</p>",
          }
          ,
          popupTemplate: infoTemplate
        });

      this.addGraphic(g, true);
      this.centralizarMapa(g.geometry, 16);
    }
    else {
      const graphics = this.layers[this.controlStatus.currentState].graphics;

      for (let i = 0; i < graphics.items.length; i++) {
        if (graphics.items[i].attributes && graphics.items[i].attributes.ID != undefined) {
          if (graphics.items[i].attributes.ID == ponto.IdCoordenada) {
            this.removeGraphic(graphics.items[i]);
            break;
          }
        }
      }
    }
  }

  retornaIcone(item) {
    let codigo = 0;
    let icone: string;

    if (isNull(item.IdRoteiroSituacao) && isNull(item.IdRoteiroPedidoSituacao)) {
      codigo = item.CodigoAcao;
    } else if (!isNull(item.IdRoteiroSituacao)) {
      switch (item.IdRoteiroSituacao) {
        case 1: codigo = 18; break;  //Roteiro - Novo
        case 2: codigo = 8; break; //Roteiro - Iniciado
        case 3: codigo = 9; break; //Roteiro - Pausado
        case 4: codigo = 10; break; //Roteiro - Saída
        case 5: codigo = 19; break; //Roteiro - Finalizado
      }
    } else {
      switch (item.IdRoteiroPedidoSituacao) {
        case 1: codigo = 20; break; //Entrega em aberto
        case 2: codigo = 3; break; //Check-in
        case 3: codigo = 4; break; //Início da Entrega
        case 4: codigo = 16; break; //RotaGPSAcao
        case 5: codigo = 17; break; //Recebimento recusado
        case 6: codigo = 5; break; //Entrega Realizada
        case 8: codigo = 15; break; //Entrega Realizada com exceção > criar com ponto de exclação
      }
    }

    let options = { icone: 'RotaGPSAcao' + codigo.toString() }
    icone = this.svgService.geraSVG(options)

    return icone;
  }

  async loadPoints() {
    // Carrega o ultimo ponto de cada caminhão
    this.ultimaPosicao = await this.routeService.ultimaPosicao();

    this.criarPontoRota(this.ultimaPosicao, true);
  }

  public CriaPontoMapa(latitude, longitude) {
    if (latitude == undefined || longitude == undefined) {
      return;
    }

    var pt = new LoadedModules.Point(0, 0, this.map.spatialReference);

    pt.latitude = latitude;
    pt.longitude = longitude;

    return pt;
  }

  private criarInfoTemplate() {
    let popupTemplate = new LoadedModules.PopupTemplate();
    popupTemplate.title = "Cliente";
    popupTemplate.content = "";
  }


  fixGraphicOrder(init: number) {
  const list = this.routeService.SelectedClients;
    for (let i = init - 1, len = list.length; i < len; i++) {
      list[i].graphic.symbol = this.createSymbol(list[i]); 
    }
  }

  toggleGraphicSelect(graphic: any) {
    if (graphic.attributes === undefined || graphic.attributes.CDCLIENT === undefined) { return; }
    const client = this.routeService.toggleSelect(graphic.attributes.CDCLIENT);

    graphic.symbol = this.createSymbol(client); // ✅

    if (client.selected) {
      const layer = graphic.layer;
      if (layer) {
        layer.remove(graphic);
        layer.add(graphic);
      }
    }

    if (!client.selected) { this.fixGraphicOrder(client.order); }

    this.limparRota();
  }

  addGraphic(g: any, sendBack: boolean, layerNumber?: any) {
    let aux;
    if (!isNullOrUndefined(layerNumber)) {
      aux = this.layers[layerNumber].add(g);
    }
    else {
      aux = this.layers[State.visualizadorDeRoteiros].add(g);
    }

    if (sendBack) {
    }
  }

  removeGraphic(g: any) {
    this.layers[State.visualizadorLinhasPontos].remove(g);
    this.layers[State.visualizadorDeRoteiros].remove(g);
  }

  resetExtent(hideDisable: boolean, objs: any) {
    let extent = null,
      graphics = objs;
    if (objs === undefined || objs.length === 0) {
      graphics = this.layers[State.visualizadorLinhasPontos].graphics.concat(
        this.layers[State.visualizadorDeRoteiros].graphics
      );
    }
    const CheckExtent = function (point) {
      if (point === undefined || point.x === undefined) { return; }
      if (extent == null) {
        extent = new LoadedModules.Extent(
          point.x,
          point.y,
          point.x,
          point.y,
          graphicService.map.spatialReference
        );
        return;
      }
      if (extent.xmax < point.x) { extent.xmax = point.x; }
      if (extent.xmin > point.x) { extent.xmin = point.x; }
      if (extent.ymax < point.y) { extent.ymax = point.y; }
      if (extent.ymin > point.y) { extent.ymin = point.y; }
    },
      leftCorrection = function () {
        try {
          const f = 0.30;
          extent.xmin -= (extent.xmax - extent.xmin) * f;
        }
        catch (e) {
          console.log("CATCH________filtrarRoteiro");
          console.log(e);
        }
      }

    for (let i = 0; i < graphics.items.length; i++) {
      if (
        graphics.items[i].visible &&
        (
          hideDisable === undefined ||
          (
            hideDisable === false &&
            graphics.items[i].attributes !== undefined
          ) ||
          (
            hideDisable &&
            graphics.items[i].attributes !== undefined
          )
        )
      ) {
        CheckExtent(graphics.items[i].geometry);
      }
    }

    if (extent != null) {
      leftCorrection();
    this.view.extent = extent.expand(1.6);
    }
  }

  selectClientsByExtent(extent: any) {
    const graphics = this.layers[this.controlStatus.currentState].graphics;
    for (let i = 0; i < graphics.length; i++) {
      if (extent.geometry.contains(graphics[i].geometry) &&
        graphics[i].attributes !== undefined) {
        if (graphics[i].visible) {
          const client = this.routeService.getItem(graphics[i].attributes.CDCLIENT);
          if (client.selected !== true) { this.toggleGraphicSelect(graphics[i]); }
        }
      }
    }
  }

  /* Limpa o roteiro realizado caso exista no mapa */
  limparRota() {
    if (this.routeService.CurrentRouteGraphic != null) {
      this.removeGraphic(this.routeService.CurrentRouteGraphic);
      this.removeGraphic(this.routeService.PontoInicial);
      this.routeService.CurrentRouteGraphic = null;
      this.routeService.CurrentRoute = null;
    }
  }

  async limparPontosMapa() {
    const graphicsLinhaPonto = this.layers[State.visualizadorLinhasPontos].graphics;
    const graphicsRot = this.layers[State.visualizadorDeRoteiros].graphics;

    while (graphicsRot.items.length > 0) {
      this.removeGraphic(graphicsRot.items[graphicsRot.items.length - 1]);
      graphicsRot.splice(graphicsRot.items.length, 1);
    }
    while (graphicsLinhaPonto.items.length > 0) {
      this.removeGraphic(graphicsLinhaPonto.items[graphicsLinhaPonto.items.length - 1]);
      graphicsLinhaPonto.splice(graphicsLinhaPonto.items.length, 1);
    }
  }

  mudarVisaoMapa(state: State) {
    if (state == State.visaoGeral) {
      this.layers[State.visualizadorLinhasPontos].visible = false;
      this.layers[State.visualizadorDeRoteiros].visible = false;
    }
    else {
      this.layers[State.visualizadorLinhasPontos].visible = true;
      this.layers[State.visualizadorDeRoteiros].visible = true;
    }
  }

  async visualizarRoteiroMapa(e, contemPontosFixo: boolean, infoRota) {
    this.removeCercaEletronica();
    this.removeCaminhaAjudMotorista()
    this.linhaRotaPlanejada = null;
    let geometry;
    let pedagio: any;
    let pt: any;
    let servico = false;
    let routeSymbol = {
      join: "round",
      type: "simple-line",
      color: [0, 0, 255, 0.5],
      width: "4px",
    };

    let infoRoteirizacao = JSON.parse(infoRota).InfoRoteirizacao ?? null;
    if(infoRoteirizacao && infoRoteirizacao.cercaEletronica){    
      this.insereCercaEletronica(infoRoteirizacao.cercaEletronica);
    }
  

   
    if(e) {
      if (e.newVersion) {
  
        if (e.stops) {
          pt = new LoadedModules.Point(e.mergedGeometry.paths[0][0][1], e.mergedGeometry.paths[0][0][0]);
          e.mergedGeometry.paths[0] = e.mergedGeometry.paths[0].map((element) => LoadedModules.WebMercatorUtils.lngLatToXY(element[1], element[0]));
  
          let geometria = e.mergedGeometry;
          geometry = LoadedModules.JsonUtils.fromJSON(geometria);
        } else {
          geometry = new LoadedModules.Polyline(e.mergedGeometry);
          pt = new LoadedModules.Point(e.mergedGeometry.paths[0][0][0], e.mergedGeometry.paths[0][0][1]);
        }
        pedagio = e.pedagio;
      }
      else if (e.stops) {
        // Roteirização através do serviço
        geometry = LoadedModules.JsonUtils.fromJSON(e.routes.features[0].geometry);
  
        // Retorna o primeiro ponto da rota - ponto inicial de saída
        pt = new LoadedModules.Point(geometry.paths[0][0][0], geometry.paths[0][0][1]);
  
        servico = true;
      }
      else if (e.result) {
        geometry = LoadedModules.JsonUtils.fromJSON(e.result.routeResults[0].directions.mergedGeometry);
        pedagio = e.result.routeResults[0].directions.pedagio
  
        // Retorna o primeiro ponto da rota - ponto inicial de saída
        let coordenadas = new LoadedModules.Point(geometry.paths[0][0][0], geometry.paths[0][0][1], this.map.spatialReference);
        let lgnLong = LoadedModules.WebMercatorUtils.webMercatorToGeographic(coordenadas)
        pt = this.CriaPontoMapa(lgnLong.latitude, lgnLong.longitude)
  
  
      }
      else if (e.paths) {
        // Roteirização automatica multi veiculos
        let polylineJson = {
          "paths": e.paths,
          "spatialReference": e.spatialReference
        };
  
        // Retorna o primeiro ponto da rota - ponto inicial de saída
        pt = new LoadedModules.Point(e.paths[0][0][0], e.paths[0][0][1]);
  
        geometry = new LoadedModules.Polyline(polylineJson);
      }
    }   

    
    //Adiciona os pontos de barreira
    if(e != null){
      if (e.pointBarriers) {
        let barreiras = e.pointBarriers
        barreiras.forEach((elemento) => {
          const coordenadas = LoadedModules.WebMercatorUtils.xyToLngLat(elemento.geometry.x, elemento.geometry.y);
          var point = new LoadedModules.Point({
            x: coordenadas[0],
            y: coordenadas[1]       
          });

          const url = this.svgService.geraSvgBarreiraa();
          var pointSymbol = new LoadedModules.PictureMarkerSymbol({
            url: url,
            width: "32px",
            height: "32px"
          });         
        
          // Criando o gráfico com o ponto e o símbolo
          var pointGraphic = new LoadedModules.Graphic({
            geometry: point,
            symbol: pointSymbol
          });          
          this.view.graphics.add(pointGraphic);
        })
      }
      if (e.polylineBarriers) {
        let barreiras = e.polylineBarriers
        barreiras.forEach((elemento) => {
          const paths = elemento.geometry.paths[0].map((path) => {
            const coordenadas = LoadedModules.WebMercatorUtils.xyToLngLat(path[0], path[1]);
                return [coordenadas[0], coordenadas[1]];
              });
            const polyline = new LoadedModules.Polyline({
                paths,
                spatialReference: this.view.spatialReference
            });
            const polylineWM = LoadedModules.WebMercatorUtils.geographicToWebMercator(polyline);
            const symbol = {
                type: "simple-line",
                color: [255,0,0], 
                width: 2
            };
            var polylineGraphic = new LoadedModules.Graphic({
                geometry: polylineWM,            
                symbol: symbol
            });
          this.view.graphics.add(polylineGraphic)
        })
      }
      if (e.polygonBarriers) {  
        let barreiras = e.polygonBarriers
        barreiras.forEach((elemento) => {
          let rings = elemento.geometry.rings[0].map((path) => {
            const coordenadas = LoadedModules.WebMercatorUtils.xyToLngLat(path[0], path[1])
            return [coordenadas[0], coordenadas[1]]
          })   
          var polygon = new LoadedModules.Polygon({
            rings
          });
          const polygonWM = LoadedModules.WebMercatorUtils.geographicToWebMercator(polygon);
          var symbol = {
            type: "simple-fill",
            color: [150, 150, 150, 0.5], // cor do preenchimento do polígono 
            outline: {
              color: [255,0,0], 
              width: 2
            }
          };
          var polygonGraphic = new LoadedModules.Graphic({
            geometry: polygonWM,
            symbol: symbol
          });
          this.view.graphics.add(polygonGraphic)
        })
      }
    }



    if (!contemPontosFixo) {
      // Insere o ponto inicial
      let symbol = new LoadedModules.PictureMarkerSymbol
        ({
          "url": 'assets/img/icon-ponto-partida.png',
          "height": 38,
          "width": 26,
          "contentType": "image/svg+xml"
        });

      let gp = new LoadedModules.Graphic({
        geometry: pt,
        symbol: symbol,
        attributes: { 'PontoInicial': 1 }
      });
      setTimeout(() => {
        this.addGraphic(gp, false, State.visualizadorDeRoteiros);
      }, 1000);
    }

    this.linhaRotaPlanejada = new LoadedModules.Graphic({
      geometry: geometry,
      symbol: routeSymbol
    });
    this.addGraphic(this.linhaRotaPlanejada, true, State.visualizadorLinhasPontos);

    if (!servico) {
      try {
        this.resetExtent(true, []);
      }
      catch (e) {
        console.log("CATCH________visualizarRoteiroMapa");
        console.log(e);
      }
    }

    // Exibe os pedágios
    if (pedagio) {
      this.listaPedagios = []
      let valorTotalPorPedagio = 0;
      let quantidadePassagemPegadio = 0;
      for (let i = 0; i < pedagio.length; i++) {
        let item = pedagio[i];
        quantidadePassagemPegadio = 0;
        pedagio.forEach(ped => {
          if (item.IdRodovia === ped.IdRodovia && item.Km === ped.Km) {
            quantidadePassagemPegadio++;
            valorTotalPorPedagio += pedagio[i].Valor;
          }
        });
        item.Valor = valorTotalPorPedagio * quantidadePassagemPegadio;
        let point = this.CriaPontoPedagioMapa(item.Latitude1, item.Longitude1);
        this.exibePedagioMapa(item, point, quantidadePassagemPegadio);
      }
    }

  }

  async visualizarRoteiroMapaAux(eAux) {
    this.linhaRotaPlanejada = null;
    let geometry;
    let pt: any;
    let routeSymbol = {
      join: "round",
      type: "simple-line",
      color: [0, 255, 255, 0.7],
      width: "4px",
    };

    if (eAux.newVersion) {
      pt = new LoadedModules.Point(eAux.mergedGeometry.paths[0][0][1], eAux.mergedGeometry.paths[0][0][0]);
      eAux.mergedGeometry.paths[0] = eAux.mergedGeometry.paths[0].map((element) => LoadedModules.WebMercatorUtils.lngLatToXY(element[1], element[0]))
      geometry = LoadedModules.JsonUtils.fromJSON(eAux.mergedGeometry);
    } else {
      geometry = LoadedModules.JsonUtils.fromJSON(eAux.result.routeResults[0].directions.mergedGeometry);
      // Retorna o primeiro ponto da rota - ponto inicial de saída
      pt = new LoadedModules.Point(geometry.paths[0][0][0], geometry.paths[0][0][1], this.map.spatialReference);
    }

    // Insere o ponto inicial
    let symbol = new LoadedModules.PictureMarkerSymbol
      ({
        'url': 'assets/img/icon-ponto-partida.png',
        'height': 38,
        'width': 26,
        'contentType': 'image/svg+xml'
      });

    let gp = new LoadedModules.Graphic({
      geometry: pt,
      symbol: symbol,
      attributes: { 'PontoInicial': 1 }
    });

    this.linhaRotaPlanejada = new LoadedModules.Graphic({
      geometry: geometry,
      symbol: routeSymbol
    });
    this.addGraphic(this.linhaRotaPlanejada, true, State.visualizadorLinhasPontos);
    setTimeout(() => {
      this.addGraphic(gp, false, State.visualizadorDeRoteiros);
    }, 1000);
  }

  async visualizarPontosMapa(pontosOriginal, pontosComUltimaPosicao) {
    let pontos = pontosComUltimaPosicao.map((item, index) => {
      if (item.CodigoAcao == 1) {
        return { ponto: item, index: index };
      }
    }).filter((item) => { if (item != undefined) return item }).reduce((acc, curr) => {
      const x = acc.find(value => value.ponto.CodigoAcao === curr.ponto.CodigoAcao && value.ponto.Data === curr.ponto.Data && value.ponto.Latitude === curr.ponto.Latitude && value.ponto.Longitude === curr.ponto.Longitude);
      if (!x) {
        return acc.concat([curr]);
      } else {
        return acc;
      }
    }, []);

    this.linhaRota = [];
    this.pontoRota = [];

    let pontoAnterior: any = null;
    let dataFinalAnterior = null;
    let pontoInicial = { Latitude: 0, Longitude: 0 };

    this.percentualDistancia = 0;
    this.distanciaTotalRealizada = 0;
    let caminhao = false;
    let kmPercorrida = JSON.parse(this.boxListTruckService.listTruckService.InfoRota).KmPercorrido;
    let controladorCalculoDistancia = true;

    //filtra pontos versao >= 2.0.0
    let versaoApp = graphicService.boxListTruckService.listTruckService.VersaoApp;
    if (versaoApp >= '2.0.0' && this.util.cnpjEmpresas.length > 0) {
      let filtroCnpjs = pontos.filter((ponto) => {
        let cnpj = JSON.parse(ponto.ponto.Informacoes).cnpj
        return this.util.cnpjEmpresas.includes(cnpj)
      });
      pontos = filtroCnpjs;
    }

    //filtra coordenada ajudante
    pontos = pontos.filter((ponto) => {
      let entregaAjudante = JSON.parse(ponto.ponto.Informacoes).CoordAjudante
      return entregaAjudante == 1? false: true
    })  
 
    //#region Adiciona pontos na tela
    for (let i = 0; i < pontos.length; i++) {
      let listaUltimaPosicao = [];
      if (pontos.length != i + 1) {
        listaUltimaPosicao = pontosComUltimaPosicao.slice(pontos[i].index, pontos[i + 1].index).reduce((acc, curr) => {
          const x = acc.find(value => value.CodigoAcao === 1 && value.CodigoAcao === curr.CodigoAcao && value.Data === curr.Data && value.Latitude === curr.Latitude && value.Longitude === curr.Longitude);
          if (!x) {
            return acc.concat([curr]);
          } else {
            return acc;
          }
        }, []).slice(1);
      }

      let parado = listaUltimaPosicao.length > 0 ? true : false;
      let dataFinal = null;
      let tempo = 0;

      if (parado) {
        dataFinal = listaUltimaPosicao[listaUltimaPosicao.length - 1].Data;
        tempo = (this.util.converteData(new Date(dataFinal)).getTime() - this.util.converteData(new Date(pontos[i].ponto.Data)).getTime());
      }

      if (!pontos[i].ponto.Data.includes('Z')) {
        let data = new Date(pontos[i].ponto.Data);
        data.setHours(data.getHours() - 3);
        pontos[i].ponto.Data = data.toISOString();
      }

      let infoTemplate = this.criarInfoTemplateRota((i + 1), pontos[i].ponto, dataFinal);    

      if(pontos[i + 1] != undefined &&  pontos[i].ponto.ChaveDispositivo !=  pontos[i + 1].ponto.ChaveDispositivo){
        tempo = 0
      }

      let temAlerta = pontos[i].ponto.TipoAlerta != null;
      let symbol = this.createSymbolRota(tempo, temAlerta);

      if ((i + 1) == pontos.length || (pontos[i + 1] != undefined &&  pontos[i].ponto.ChaveDispositivo !=  pontos[i + 1].ponto.ChaveDispositivo) ) {
        symbol = this.createSymbol(pontos[i].ponto, 1 ,  JSON.parse(this.boxListTruckService.listTruckService.InfoRota).CategoriaPedagioID ?? 0);
        caminhao = true;
      }else{
        caminhao = false
      }

      let ponto = this.CriaPontoMapa(pontos[i].ponto.Latitude, pontos[i].ponto.Longitude);

      let g = new LoadedModules.Graphic
        ({
          geometry: ponto,
          symbol: symbol,
          attributes: {
            'PontoRota': (i + 1),
          },
          popupTemplate: infoTemplate
        });

      if (caminhao) {
        this.addGraphic(g, true);
        caminhao = false;
      }
      else {
        this.addGraphic(g, false, State.visualizadorLinhasPontos);
      }

      this.pontoRota.push(g);

      if (pontoAnterior != null) {
        // Calcula a distância

        if (kmPercorrida === undefined) {
          if(pontos[i].ponto.ChaveDispositivo ==  pontos[i - 1].ponto.ChaveDispositivo){
            let distancia = this.util.calcularDistanciaGeo(pontos[i - 1].ponto.Latitude, pontos[i - 1].ponto.Longitude, pontos[i].ponto.Latitude, pontos[i].ponto.Longitude);
            this.distanciaTotalRealizada += distancia;
          }

        } else if (controladorCalculoDistancia) {
          this.distanciaTotalRealizada = parseFloat(kmPercorrida);
          controladorCalculoDistancia = false;
        }


        let line = new LoadedModules.Polyline(this.map.spatialReference);
        line.addPath([pontoAnterior, ponto]);

        let dataTemp = dataFinalAnterior == null ? pontos[i - 1].ponto.Data : dataFinalAnterior;
        let semCoordenadas = this.calculaTempoSemCoordenada(dataTemp, pontos[i].ponto.Data);

        let linha = this.createSymbolLinha(semCoordenadas);

        let lineGraphic = new LoadedModules.Graphic({
          geometry: line,
          symbol: linha
        });

        this.linhaRota.push(lineGraphic);
        //linha
        if(pontos[i].ponto.ChaveDispositivo ==  pontos[i - 1].ponto.ChaveDispositivo){
          this.addGraphic(lineGraphic, true, State.visualizadorLinhasPontos);
        }
      }
      pontoAnterior = ponto;
      dataFinalAnterior = dataFinal;
    }

    document.getElementById('atualizaIconeKmPercorrida').click()
    if (this.distanciaTotalRealizada > this.distanciaTotalPlanejada) {
      this.percentualDistancia = (1 - (this.distanciaTotalPlanejada / this.distanciaTotalRealizada)) * 100;
    }

    //#endregion
  }

  calculaTempoSemCoordenada(dataPonto1, dataPonto2) {
    let tempo = this.util.converteData(new Date(dataPonto2)).getTime() - this.util.converteData(new Date(dataPonto1)).getTime();
    return tempo >= 600000 ? true : false;
  }

  createSymbolLinha(semCoordenadas) {
    let lineSym = {
      type: "simple-line",
      color: semCoordenadas ? [255, 0, 0] : [0, 0, 0],
      style: semCoordenadas ? "dash" : "solid",
      width: 3,

    };
    return lineSym;
  }

  createSymbolRota(tempo, alerta = false) {
    let cor = tempo == 0 ? [255, 255, 255] : tempo > 1800000 ? [255, 52, 31] : 600000 < tempo && tempo <= 1800000 ? [255, 161, 0] : [80, 228, 80];
    let borda = tempo == 0 ? [0, 0, 0] : tempo > 1800000 ? [189, 0, 0] : 600000 < tempo && tempo <= 1800000 ? [173, 109, 0] : [53, 150, 53];

    let pointSym = new LoadedModules.SimpleMarkerSymbol
      (
        {
          "color": alerta? [188,138,225]: cor,
          "size": 6,
          "outline":
          {
            "color": alerta? [156,68,190] : borda,
            width: 1
          }
        }
      );

    return pointSym;
  }

  private criarInfoTemplateRota(contador: number, ponto: any, dataFinal?) {
    let dt = this.util.converteData(new Date(ponto.Data));

    let informacaoComplementarTemplate = '';
    let ObjInformacoes = JSON.parse(ponto.Informacoes);
    let versaoApp = graphicService.boxListTruckService.listTruckService.VersaoApp;
    if (versaoApp >= '2.0.0') {
      informacaoComplementarTemplate +=
      `<hr>`+
      `<div class="d-flex mb-2">
        <img src="assets/img/icons/icon_mapfill.svg" class="mr-1"> 
        <span class="font-weight-bold mt-1 ml-1">Informações Gerais</span>
      </div>`
      if (!isNullOrUndefined(dataFinal)){
        let dtfinal = this.util.converteData(new Date(dataFinal));
        const permanencia = this.util.secondsToHMS((dtfinal.getTime() - dt.getTime()) / 1000)
        informacaoComplementarTemplate +=
        `<div class="ml-4">Permanência:  ${permanencia} </div>`
      }
      informacaoComplementarTemplate +=
        `<div class="ml-4">Altitude: ${ObjInformacoes.altitude.toFixed(2)} metros acima do nível do mar </div>` +
        `<div class="ml-4">Velocidade aproximada: ${ObjInformacoes.speed.toFixed(2)} km/h</div>` +
        `<div class="ml-4">Veículo em movimento: ${ObjInformacoes.veiculoEmMovimento ? 'Sim' : 'Não'} </div>`+
        `<div class="ml-4">Bateria estava sendo carregada: ${ObjInformacoes.bateriaCarregando ? 'Sim' : 'Não'} </div>`
        
    }
    if (ponto.IdRoteiroPedidoSituacao == null && ponto.IdRoteiroSituacao == null) {
      informacaoComplementarTemplate += `<br> <div class="d-flex justify-content-end">  <button type="button"  onclick="desativarCoordenada(${ponto.IdCoordenada})" ` +
        `class="btn btn-danger btn-sm">Desativar coordenada </button> </div>`
    } 

    let divAlerta = ''

    let popupTemplate = new LoadedModules.PopupTemplate();

    if(ponto.TipoAlerta != null || ponto.CodigoOcorrencia != null ){

      divAlerta += `<div> Ponto ${contador}</div>`
      divAlerta += `<div class="mt-1 d-flex justify-content-between" style="width:400px" >`
      
      if(ponto.TipoAlerta != null){

        divAlerta += `
        <div style="color: #D32F2F"> 
          <i class="fa fa-exclamation-circle"> </i> 
          ${ponto.TipoAlerta}    
        </div>  
        `
      }

      if(ponto.CodigoOcorrencia != null){
        divAlerta += `
        <div style="color: #96989B"> 
          <i class="fa fa-tag" > </i>
          <span style="color: #000"> ${ponto.CodigoOcorrencia}  </span>  
        </div>  
        `
      }

      divAlerta += `</div>`    

      popupTemplate.title = divAlerta;
   
    }else{
      popupTemplate.title = "Ponto " + contador;
    }

    
    if (!isNullOrUndefined(dataFinal)) {
      let dtfinal = this.util.converteData(new Date(dataFinal));
      const permanencia = this.util.secondsToHMS((dtfinal.getTime() - dt.getTime()) / 1000)
      popupTemplate.content = function (feature) {
        const obj = feature.graphic.attributes;
        const div = document.createElement("div")
        div.innerHTML =
          `
                <div class="p-2">
                  <div>
                    <div class="d-flex mb-2">
                      <img src="assets/img/icons/icon_CalendarEventFill.svg" class="mr-1">
                      <span class="font-weight-bold mt-1 ml-1">Data</span>
                    </div>
                    <div class="ml-4">Início:  ${dt.toLocaleDateString()} ${dt.toLocaleTimeString()}  </div>
                    <div class="ml-4">Fim:  ${dtfinal.toLocaleDateString()} ${dtfinal.toLocaleTimeString()} </div>
                  </div>${informacaoComplementarTemplate}
                <div>
              `;
        return div;
      }
    } else {
      popupTemplate.content = function (feature) {
        const obj = feature.graphic.attributes;
        const div = document.createElement("div")
        div.style.padding = '8px'
        div.innerHTML =
          `
              <img src="assets/img/icons/icon_CalendarEventFill.svg" class="mr-1 mb-1">
              <span class="font-weight-bold">Data:</span> ${dt.toLocaleDateString()} ${dt.toLocaleTimeString()}  ${informacaoComplementarTemplate}
            `;
        return div;
      }
    }

    return popupTemplate;
  }

  private criarInfoTemplateRoteiro(ultimaPosicao: boolean, cliente: any, acoes: any[]) {
    let popupTemplate = new LoadedModules.PopupTemplate();

    if (ultimaPosicao) {
      popupTemplate.title = "Posição Atual";
      popupTemplate.content = function (feature) {
        const obj = feature.graphic.attributes;
        const div = document.createElement("div")
        div.innerHTML =
          `
              "Data: ${obj.DATA}";
              `;
        return div;
      }
    }
    else {
      popupTemplate.title = "<span style='color: #101316; font-size: 20px;'>Cliente</span>";

      let aviso = '';


      if (cliente.statusEntrega > 1 && acoes.length == 0) {
        aviso = `<br>
              <div class="text-left">
                <i class="mt-1 fa fa-exclamation-triangle text-center text-danger fa-2x data-bs-toggle="tooltip" data-bs-placement="top"
                title="As ações de início e fim da entrega não foram acompanhadas do sinal de GPS impossibilitando nossos cálculos de tempo. Verifique com o motorista se o funcionamento do GPS esta ativado."></i>
              <div>          `
      }

      let entregaAjudante = false;
      acoes.forEach((acao) => {
        let informacoes = JSON.parse(acao.Informacoes).CoordAjudante
        entregaAjudante = informacoes == 1 ? true: false;
      })


      popupTemplate.content = function (feature) {
        const obj = feature.graphic.attributes;
        const div = document.createElement("div")

        let layoutOcs = '';
        let decimalPipe = new DecimalPipe('pt-BR'); 
        let custoDescarga = ''
        let valorFormatado = decimalPipe.transform(obj.custoDescarga, '1.2-2')

        const clienteTemOcs = graphicService.boxInfoAlertService.alertRouter.some((cliente) => cliente.CodigoCliente == obj.CDCLIENT);
        if(clienteTemOcs){
          const ocorrencias = graphicService.boxInfoAlertService.alertRouter.filter((cliente) => cliente.CodigoCliente == obj.CDCLIENT)
          
          layoutOcs += `<span class="tit-principal-oc"> Ocorrência(s) no cliente (${ocorrencias.length})</span>`
            
          ocorrencias.forEach((ocorrencia) => {
            layoutOcs += `
              <div class="container-oc">
                <div class="content-oc">
                  <div class="dados-oc">
                    <span>${ocorrencia.Motivo} - ${ocorrencia.CodigoOcorrencia}</span>
                    <img class="ml-2" src="assets/img/icons/ticket.svg" alt="">
                  </div>
                  <div class="data-oc">${Util.formatarDataHora(ocorrencia.Data)}</div>
                </div>
                <div class="content-btn-oc">
                  <span 
                    data-tooltip="Visualizar mensagem" 
                    data-tooltip-pos="top"
                    data-codigo-ocorrencia="${ocorrencia.CodigoOcorrencia}"
                    id="btn-visualizar-msg-${ocorrencia.CodigoOcorrencia}"
                    class="btn-visualizar-msg">
                    <img class="ml-2" src="assets/img/icons/chat-right-text.svg" alt="">
                  </span>
                  <span 
                    data-tooltip="Ir para ocorrência" 
                    data-tooltip-pos="top"
                    id="btn-abrir-ocorrencia-${ocorrencia.CodigoOcorrencia}"
                    data-codigo-ocorrencia="${ocorrencia.CodigoOcorrencia}">
                    <img class="p-2" src="assets/img/icons/box-arrow-up-right.svg" alt="">
                  </span>
                </div>
              </div>
            `;
          });
          layoutOcs += `</div>`
        }

        if(obj.custoDescarga){
          custoDescarga = `
            <div class="d-flex">
              <img src="assets/img/icon_descarga_popup.svg" class="mr-1"> 
              <span>Custo descarga: <span class="font-weight-bold"> R$ ${valorFormatado}</span> </span>
            </div>
          `
        }

        let layoutListaAcoes = ''
        let layoutAjudante = ''
        let listaDeAcoes = []
        if (obj.listaDeAcoes) {
          listaDeAcoes = obj.listaDeAcoes
          layoutListaAcoes = '<p class="tit-principal mb-0 mt-3"> Histórico de ações </p><div class="lista-acoes-popup" *ngIf="listaDeAcoes.length > 0">'
          if (obj.CDCLIENT != undefined && listaDeAcoes != undefined && listaDeAcoes.length > 0) {
          
            for (let i = 0; i < listaDeAcoes.length; i++) {
              let item = listaDeAcoes[i];
            
              let escondeLinha = (i + 1) % 5 === 0 || i + 1 == listaDeAcoes.length;
            
              if (item.data != null && item.hora != null) {
                layoutListaAcoes += `<div class="item-lista-acoes"> 
                  <img class="lista-acoes-popup-items-img" src='` + item.icone + `'>`
                
                  if(!escondeLinha){
                    layoutListaAcoes += '<span class="teste" [hidden]="${isHidden}"> </span>'
                  }

                  layoutListaAcoes += `
                    <span class="status-acoes mt-1">` + item.descricaoStatus + `</span>
                    <span class="status-data">` + item.data + `</span>
                    <span class="status-data">` + item.hora + `</span> </div>;
                  `  
                
              } else {
                layoutListaAcoes += `<div class="item-lista-acoes"> <img class="lista-acoes-popup-items-img" src='` + item.icone + `'> </div>`;
              }
            }
            layoutListaAcoes += '</div>'
          }
        }

        if (listaDeAcoes.length == 0) {
          layoutListaAcoes = '';
        }

        if(entregaAjudante){
          layoutAjudante = `<div class="card-ajudante"> Entrega realizada pelo ajudante </div>`
        }

        div.innerHTML = `
          <div id="esriPopUpWrapper">
            <div> 
              <div>
                <div class="header-pop-cliente">
                  <div> 
                    <span class="nome-fantasia-pop mr-2"> ${obj.NOME}</span>
                    <span>${obj.CDCLIENT}</span>
                  </div>
                  <button style="border: none; background: none" onclick="AbreStreetViewPrincipal(${obj.LATITUDE},${obj.LONGITUDE})">
                    <img src="assets/img/icons/icon_eye_green.svg"> 
                  </button>
                </div>
                <p class="pp-nome-fantasia-cliente">${obj.NOMEFANTASIA}</p>
              </div>                
            </div>
        
            <div class="dados">
              <div class="info-cliente">
                <p class="pp-doc-cliente"><span>${obj.DOC}</span></p>
                <div class="endereco-cliente">
                  <p class="endereco-cliente-popup">${obj.ENDERECO}</p>
                  <p class="endereco-cliente-popup">${obj.BAIRRO} - ${obj.MUNICIPIO}/${obj.UF}</p>
                  <p class="endereco-cliente-popup">CEP: ${obj.CEP}</p>
                </div>
              </div>
            </div>
            ${custoDescarga}
          
            <div class="footer">
              ${layoutAjudante}
              ${aviso}
              ${layoutListaAcoes}
              ${layoutOcs}
            </div>
          </div>
        `;

        div.querySelectorAll('[id^="btn-visualizar-msg-"]').forEach((btn) => {
          btn.addEventListener('click', async () => {
            const codigoOc = btn.getAttribute('data-codigo-ocorrencia');
            const objMensagem = await graphicService.boxInfoAlertService.getOcorrenciaMensagem(codigoOc);

            const isBase64Image = (text: string): boolean => {
              const base64ImagePrefixes = ['/9j/', 'iVBOR', 'R0lGO', 'Qk0', 'SUkq'];
              return base64ImagePrefixes.some(prefix => text.trimStart().startsWith(prefix));
            };

            const mensagemValida = objMensagem.find(
              (msg: any) => msg?.Mensagem && !isBase64Image(msg.Mensagem)
            );

            const mensagemTexto = mensagemValida?.Mensagem ?? '';

            graphicService.ngZone.run(() => {
              if (mensagemTexto.includes('Motivo:')) {
                const motivoMatch = mensagemTexto.match(/Motivo: <\/b>(.*?)(?:\\n|$)/);
                graphicService.boxInfoAlertService.mensagemModal = motivoMatch ? motivoMatch[1].trim() : '';
              } else {
                graphicService.boxInfoAlertService.mensagemModal = mensagemTexto.trim();
              }
              graphicService.boxInfoAlertService.dataModal = mensagemValida?.Data ?? objMensagem[0]?.Data;
              const ocorrencias = graphicService.boxInfoAlertService.alertRouter.filter((cliente) => cliente.CodigoCliente == obj.CDCLIENT)
              graphicService.boxInfoAlertService.ocorrenciaAtualModal = ocorrencias.find(
                o => o.CodigoOcorrencia == codigoOc
              );
              
              graphicService.boxInfoAlertService.abrirOcorrenciaCallback = (item) => {
                const opc6 = {
                  roteiro: graphicService.boxListTruckService.roteiroSelecionado,
                  codigoOcorrencia: item.CodigoOcorrencia
                };
                const novaData = btoa(
                  new Date().getUTCFullYear() + '-' +
                  (new Date().getUTCMonth() + 1) + '-' +
                  new Date().getUTCDate() + " " +
                  new Date().getHours() + ":" +
                  new Date().getMinutes()
                );
                const analisaUrl = new URL(graphicService.urlOcorrencias);
                analisaUrl.searchParams.set("opc4", novaData);
                window.open(analisaUrl.toString() + `&opc6=${btoa(JSON.stringify(opc6))}`, "_blank");
              };
              
              graphicService.boxInfoAlertService.abrirModalMensagemOc = true;
            });
          });
        });

        div.querySelectorAll('[id^="btn-abrir-ocorrencia-"]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const codigoOcorrencia = btn.getAttribute('data-codigo-ocorrencia');

            const opc6 = {
              roteiro: graphicService.boxListTruckService.roteiroSelecionado,
              codigoOcorrencia: codigoOcorrencia
            };

            const novaData = btoa(
              new Date().getUTCFullYear() + '-' +
              (new Date().getUTCMonth() + 1) + '-' +
              new Date().getUTCDate() + " " +
              new Date().getHours() + ":" +
              new Date().getMinutes()
            );

            const analisaUrl = new URL(graphicService.urlOcorrencias);
            analisaUrl.searchParams.set("opc4", novaData);
            const finalUrl = analisaUrl.toString();

            window.open(finalUrl + `&opc6=${btoa(JSON.stringify(opc6))}`, "_blank");
          });
        });

        return div;
      }
      return popupTemplate;
    }
    return popupTemplate;
  }

  private criarInfoTemplateAcao() {
    let popupTemplate = new LoadedModules.PopupTemplate();
    popupTemplate.title = "{TITULO}";
    popupTemplate.content = function (feature) {
      const obj = feature.graphic.attributes;
      const div = document.createElement("div")
      div.innerHTML =
        `
            ${obj.CORPO}
          `;
      return div;
    }
    return popupTemplate;
  }

  async visualizarRoteiroCliente(e) {
    await this.criarPontoRota(e);
  }

  retornarPontoCliente(codigo: number) {

    const graphics = this.layers[State.visualizadorLinhasPontos].graphics.concat(
      this.layers[State.visualizadorDeRoteiros].graphics
    );

    for (let i = 0; i < graphics.length; i++) {
      if (graphics.items[i].attributes && graphics.items[i].attributes.CDCLIENT != undefined) {
        if (graphics.items[i].attributes.CDCLIENT == codigo) {

          this.centralizarMapa(graphics.items[i].geometry, 16);
          break;
        }
      }
    }
  }

  retornarPontoCoordenada() {  
    this.view.goTo({
      center: [this.coordenadaCenter.longitude , this.coordenadaCenter.latitude ],
      zoom: 15
    }); 
  }  

  centralizarMapa(point, zoom) {
    if (point != undefined) {
      if (zoom) {
        this.view.goTo({
          center: [point.x, point.y],
          zoom: zoom
        });
      }
      else {
        this.view.goTo({
          center: [point.x, point.y],
        });
      }
    }
  }

  redimensionaMapa() {

    let wait = setTimeout(() => {
      clearTimeout(wait);
    }, 700);
  }

  exibirDistanciaPercorrida(exibir: boolean) {
    let contador = this.pontoRota.length - 2;

    while (contador >= 0) {
      if (exibir) {
        this.addGraphic(this.pontoRota[contador], true, State.visualizadorLinhasPontos); 
      }
      else {
        this.removeGraphic(this.pontoRota[contador]);
      }

      contador--;
    }

    contador = this.linhaRota.length - 1;

    while (contador >= 0) {
      if (exibir) {
        this.addGraphic(this.linhaRota[contador], true, State.visualizadorLinhasPontos);
      } else {
        this.removeGraphic(this.linhaRota[contador]);
      }
      contador--;
    }
  }

  exibirDistanciaPlanejada(exibir: boolean) {
    if (exibir) {
      this.addGraphic(this.linhaRotaPlanejada, true, State.visualizadorLinhasPontos);
    } else {
      this.removeGraphic(this.linhaRotaPlanejada);
    }
  }

  public iconeAcaoPopupPorPedido(listaDeAcoes) {
    let listaAux = [];

    listaDeAcoes.forEach(item => {
      let icone = '';
      let options
      switch (item.IdRoteiroPedidoSituacao) {
        case 2:
          options = { icone: "DashboardChegouCliente" }


          break;
        case 3:
          options = { icone: "DashboardIniciouEntrega" }

          break;
        case 4:
          options = { icone: "DashboardVoltaDepois" }
          break;
        case 5:
          options = { icone: "DashboardNaoEntrega" }
          break;
        case 6:
          options = { icone: "DashboardEntregaFinalizada" }
          break;
      }

      if (icone != '') {

        let acao = {
          icone: this.svgService.geraSVG(options)
        };
        listaAux.push(acao);
      }
    });

    return listaAux;
  }

  atualizaMapView() {
    this.layers[State.visualizadorLinhasPontos].graphics.items.sort((a, b) => {
      if (b.geometry.type < a.geometry.type) {
        return -1;
      }
      if (b.geometry.type > a.geometry.type) {
        return 1;
      }
      return 0;
    })

    let pontosMapa = Array.from(this.layers[State.visualizadorLinhasPontos].graphics);

    this.layers[State.visualizadorLinhasPontos].removeAll()
    this.layers[State.visualizadorLinhasPontos].addMany(pontosMapa)

  }

  private CriaPontoPedagioMapa(latitude, longitude) {
    if (latitude == undefined || longitude == undefined) {
      return;
    }

    var pt = new LoadedModules.Point(0, 0, this.map.spatialReference);
    pt.latitude = latitude;
    pt.longitude = longitude;

    return pt;
  }
  exibePedagioMapa(item, circuloComparar, qtdPassagemPedagio?: number) {
    let vlEixo = Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.ValorEixo);
    let valor = Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.ValorEixo * qtdPassagemPedagio);
    var graphic = new LoadedModules.Graphic
      ({
        geometry: circuloComparar,
        symbol: this.configuraIconePedagio(),
        attributes: {
          "IDPRACAPEDAGIO": item.IdPracaPedagio,
          "PEDAGIO": true,
          "PRACA": item.Praca,
          "CONCESSIONARIA": item.Concessionaria,
          "RODOVIA": item.Rodovia,
          "KM": item.Km,
          "VLEIXO": vlEixo,
          "VALOR": valor,
          "SITE": item.Site,
          "LOGO": item.Logo
        },
        popupTemplate: this.configuraTemplatePedagio(qtdPassagemPedagio)
      });

    this.listaPedagios.push(item);
    this.addGraphic(graphic, true);
  }
  
  configuraTemplatePedagio(qtdPassagemPedagio: number) {
    let messagemPedagio = qtdPassagemPedagio == 1 ? 'Total Pedágio ida: ' : 'Total Pedágio ida e volta: '
    let popupTemplate = new LoadedModules.PopupTemplate();
    popupTemplate.title = "Pedágio - {PRACA}";
    popupTemplate.content = function (feature) {
      const obj = feature.graphic.attributes;
      const div = document.createElement("div")
      const displayFreeFlow: String = obj.freeFlow ? 'inline-block' : 'none';
      const displayAceitaTag: String = obj.aceitaTag ? 'inline-block' : 'none';
      const contemOcAberta = graphicService.listaOcPedagioCriada.some((IdPracaPedagio) => IdPracaPedagio == obj.IDPRACAPEDAGIO);
      let displayOcAbertaAviso: String = obj.ocAberta || contemOcAberta ? 'inline-block' : 'none';
      let htmlextra = '';
      if (obj.LOGO && obj.SITE) {
        htmlextra = `<a href="${obj.SITE}" target="_blank"><img style="margin-left: 20px; margin-right: 20px; margin-top: 8px; width: 100px; height: 100px" src="${obj.LOGO}" /></a>`;
      }
      div.innerHTML =
      `
        <div style="display: flex;">
          ${htmlextra}
          <div class='mt-2 ml-1'>
          ${obj.CONCESSIONARIA} 
          <br/>${obj.RODOVIA} - Km ${obj.KM}<br/>
          <strong>Tarifa do veículo: </strong> ${obj.VLEIXO}
          <br/><strong>${messagemPedagio} </strong> ${obj.VALOR}
            <div class='footer mb-2 mt-1'>

                  <button class='bt-popup hide-on-mobile'
                  onclick="infoOcorrenciaPedagio('${obj.PRACA}', \'${obj.VALOR}'\, ${obj.IDPRACAPEDAGIO}); bootstrap.Modal.getOrCreateInstance(document.getElementById('ocorrendiaPedagioModal')).show()">
                    <i class='fa fa-retweet'> </i> Reportar Valor Incorreto
                  </button>

                  <button type="button"
                  onclick="atualizaPrecosPrecoPedagios(
                    ${obj.IDPRACAPEDAGIO}, \'${obj.PRACA}\', \'${obj.CONCESSIONARIA}\', \'${obj.RODOVIA}\', \'${obj.KM}\' , \'${displayFreeFlow}\' , \'${displayAceitaTag}\' , \'${displayOcAbertaAviso}\' ,${obj.porcTagDesconto}
                  ); bootstrap.Modal.getOrCreateInstance(document.getElementById('precosPracaPedagio')).show()"
                  class="btn btn-outline-success mr-2 hide-on-mobile">
                    <i class="fa fa-eye mr-2"></i> 
                    Ver tabela
                  </button>
            </div>
          </div>
        </div>
      `;
      return div;
    }
    return popupTemplate;
  }

  configuraIconePedagio() {
    let iconePedagio = new LoadedModules.PictureMarkerSymbol
      (
        {
          "angle": 0,
          "xoffset": 0,
          "yoffset": 12,
          "url": "assets/img/pedagio.png",
          "contentType": "image/png",
          "width": 22,
          "height": 22
        }
      );

    return iconePedagio;
  }


  // ****************************   CONTROLES DE BARREIRAS

  criarPontoBarreira(latitude, longitude) {
    // cria a geometria da barreira e atribui o icone
    const point = {
      type: "point",
      x: longitude,
      y: latitude
    };

    const pointGraphic = new LoadedModules.Graphic({
      geometry: point,
      symbol: new LoadedModules.PictureMarkerSymbol
        ({
          url: 'assets/img/pointBarrier.png',
          height: 22,
          width: 22,
        })
    })
    //adiciona o icone ao mapa - layer 0
    this.addGraphic(pointGraphic, true, State.visualizadorLinhasPontos);
    // cria a Barreira
    const pointBarrier = new LoadedModules.PointBarrier({
      geometry: pointGraphic.geometry,
      barrierType: 'restriction',
      curbApproach: 'either-side-of-vehicle',
      fullEdge: 'restrict',
    })
    this.pointBarriers.push(pointBarrier),
      //nomeia a barreira
      pointBarrier.name = `Bloqueio de Via Nº0${this.pointBarriers.length}`
    //cria o popup da barreira
    let popupTemplate = this.gerapopUpBarreira(pointBarrier)
    pointGraphic.popupTemplate = popupTemplate;
    pointGraphic.attributes = pointBarrier.name
    pointBarrier.graphic = pointGraphic
    this.routeService.pointBarrier = this.pointBarriers
  }

  gerapopUpBarreira(barreira) {
    let popupTemplate = new LoadedModules.PopupTemplate();
    popupTemplate.title = barreira.name;
    popupTemplate.content = function (feature) {
      const div = document.createElement("div")
      let tipoBarreira = barreira.barrierType == 'restriction' ? 'Restrição' : 'Pedágio'
      div.innerHTML =
        `
        <div class='mt-2 ml-1'>
        <strong>Tipo de Barreira: </strong> ${tipoBarreira}
        <br>
        <strong>Sentido de Bloqueio: </strong>'Unidirecional'
        <br>
      </div>
        `
        ;
      return div;
    }
    return popupTemplate;
  }

  insereCercaEletronica(cercaEletronica: any) {
    const polygon = new LoadedModules.Polygon({
      rings: cercaEletronica,
      spatialReference: { wkid: 4326 }
    });
    this.polygonGraphicCerca = new LoadedModules.Graphic({
      geometry: polygon,
      symbol: {
        type: 'simple-fill',
        color: [150, 152, 155, 0.2],
        outline: {
          color: [150, 152, 155],
          width: 2
        }
      }
    });

    this.view.graphics.add(this.polygonGraphicCerca);
  }

  removeCercaEletronica(){
    if(this.polygonGraphicCerca != null){
      this.view.graphics.remove(this.polygonGraphicCerca)
      this.polygonGraphicCerca = null;
    } 
  }

  removeCaminhaAjudMotorista(){
    if(this.listaPolylineDistPercorrida){
      this.listaPolylineDistPercorrida.forEach((graphicPedido) => {
        this.view.graphics.remove(graphicPedido)
      })
    }
  }

  descricaoStatusAcao(codigo, informacoes){
    switch (codigo) {
      case 1: return 'Entrega em aberto'; 
      case 2: return 'Check-in'; 
      case 3: return informacoes.tipo == TipoEntregas.Coleta ? 'Início da Coleta' :  'Início da Entrega'; 
      case 4: return 'Volto depois';  
      case 5: return informacoes.tipo == TipoEntregas.Coleta ? 'Coleta não efetuada' :'Recebimento recusado';  
      case 6: return informacoes.tipo == TipoEntregas.Coleta ? 'Coleta realizada' : 'Entrega realizada'; 
      case 7: return informacoes.tipo == TipoEntregas.Coleta ? 'Coleta realizada com exceção' : 'Entrega realizada com exceção'; 
    }
  }

  preparaListaDisPercorrida(dados){
    let distanciaTotalPedido = 0;
    let pesoTotalPedido = 0;
    let volTotalPedido = 0;
    let inicioEntrega = '';
    this.dadosAjudMotorDisPerc = dados;
    this.dadosAjudMotorDisPerc.dadosTrecho = [];

    for (let i = 0; i < this.dadosAjudMotorDisPerc.listaAgrupadaEntrega.length; i++) {  
      distanciaTotalPedido = 0;
      pesoTotalPedido = 0;
      volTotalPedido = 0;

      const coordenadas = this.dadosAjudMotorDisPerc.listaAgrupadaEntrega[i].Entregas.map(item => JSON.parse(item.CoordenadaJSON));
      for (let k = 0; k < this.dadosAjudMotorDisPerc.listaAgrupadaEntrega[i].Entregas.length; k++) {      
        if(k > 1){      
          let distancia = this.util.calcularDistanciaGeo(
            coordenadas[k-1].latitude,
            coordenadas[k-1].longitude,
            coordenadas[k].latitude,
            coordenadas[k].longitude);
            distanciaTotalPedido += distancia;   
        }else{
          inicioEntrega = this.dadosAjudMotorDisPerc.listaAgrupadaEntrega[i].Entregas[k].DT
        }
      } 

      let pedidosEntrega = this.dadosAjudMotorDisPerc.pedidos.filter((pedido) => pedido.CodigoCliente == this.dadosAjudMotorDisPerc.listaAgrupadaEntrega[i].CodigoCliente);

      pedidosEntrega.forEach(pedido => {
        pesoTotalPedido += pedido.Peso ?? 0,
        volTotalPedido += pedido.QtdeVolumes ?? 0
      });

      this.dadosAjudMotorDisPerc.dadosTrecho.push({
        distanciaTrecho : distanciaTotalPedido.toFixed(3),
        pesoTrecho : pesoTotalPedido,
        volTrecho : volTotalPedido,
        inicioCaminhada : inicioEntrega,
        nomeCliente: this.dadosAjudMotorDisPerc.pedidos.find((pedido) => pedido.CodigoCliente == this.dadosAjudMotorDisPerc.listaAgrupadaEntrega[i].CodigoCliente).RazaoSocial,
        codCliente: this.dadosAjudMotorDisPerc.listaAgrupadaEntrega[i].CodigoCliente,
        ordemEntrega : this.dadosAjudMotorDisPerc.pedidos.find((pedido) => pedido.CodigoCliente == this.dadosAjudMotorDisPerc.listaAgrupadaEntrega[i].CodigoCliente).OrdemEntrega,
        coordenadas
      })     
    }
  }
}
